import React, { Component, Fragment } from "react"
import posed, { PoseGroup } from "react-pose"
import { connect } from "react-redux"
import MediaQuery from "react-responsive"

import Modal from "./modal"
import RegionDesktop from "./desktop"
import RegionMobile from "./mobile"

const Panel = posed.div({
  enter: {
    y: 0,
    opacity: 1,
    delay: 300,
    applyAtStart: { pointerEvents: "all" },
    transition: {
      y: {
        type: "spring",
        stiffness: 400,
        damping: 20
      },
      default: {
        duration: 400
      }
    }
  },
  exit: {
    y: -250,
    opacity: 0,
    transition: {
      duration: 350
    }
  }
})

const Shade = posed.div({
  enter: {
    opacity: 1,
    applyAtStart: { visibility: "visible", position: "fixed" }
  },
  exit: {
    opacity: 0,
    applyAtEnd: { visibility: "hidden" }
  }
})

class RegionModal extends Component {
  componentDidMount() {
    this.props.getRegions()
  }

  render() {
    const isVisible = this.props.regions.open
    return (
      <Fragment>
        <Modal onClose={this.props.setOpen} isVisible={isVisible}>
          <PoseGroup>
            {isVisible && [
              <Shade key="shade" className="blackout" onClick={() => this.props.setOpen()} />,
              <Panel key="panel" className="locationPopupWrapper">
                <div className="locationPopup">
                  <div className="locationPopupHeader">
                    <h2>Выберите ваш город</h2>
                    <button className="locationPopupClose" onClick={() => this.props.setOpen()}>
                      <svg className="icon-close">
                        <use xlinkHref="#icon-close" />
                      </svg>
                    </button>
                  </div>
                  <div className="locationPopupBody">
                    <MediaQuery query="(min-width: 1024px)">
                      <RegionDesktop />
                    </MediaQuery>
                    <MediaQuery query="(max-width: 1024px)">
                      <RegionMobile />
                    </MediaQuery>
                  </div>
                </div>
              </Panel>
            ]}
          </PoseGroup>
        </Modal>
      </Fragment>
    )
  }
}

const mapState = state => ({
  regions: state.regions
})

const mapDispatch = ({ regions: { getRegions, getRegion, setCity, open } }) => ({
  getRegions: () => getRegions(),
  getRegion: region => getRegion(region),
  setCity: city => setCity(city),
  setOpen: () => open()
})
export default connect(
  mapState,
  mapDispatch
)(RegionModal)
